import { createClient } from '@supabase/supabase-js';
import {
	UpdateFincluOperationStatusRequest,
	UpdateFincluOperationStatusResponse
} from '@/types/FincluOperationStatus';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
const supabase = createClient(supabaseUrl, supabaseKey);

export async function updateFincluOperationStatus(
	request: UpdateFincluOperationStatusRequest
): Promise<UpdateFincluOperationStatusResponse> {
	const {
		data: { session }
	} = await supabase.auth.getSession();
	const token = session?.access_token;

	if (!token) {
		throw new Error('No authentication token available');
	}

	const response = await fetch(`${supabaseUrl}/functions/v1/update-finclu-operation-status`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(request)
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Failed to update status');
	}

	return response.json();
}
